import { saleStatusHistory } from '@/config'

const detail = {
  line1: [
    {
      name: 'customerName',
      text: 'sale.sale_customer-name',
      component: 'MultipleSelectCustomerName'
    },
    {
      name: 'saleDate',
      text: 'sale.sale_order-date',
      component: 'FromToDatePicker'
    },
    {
      name: 'completionDate',
      text: 'sale.sale_completion-date',
      component: 'FromToDatePicker'
    },
    {
      name: 'paymentDay',
      text: 'payment.payment_sale-payment-date',
      component: 'FromToDatePicker'
    },
    {
      name: 'shipDate',
      text: 'ship.ship_ship-date',
      component: 'FromToDatePicker'
    }
  ],
  line2: [
    {
      name: 'paymentStatus',
      text: 'sale.sale_sale-payment-status',
      component: 'SelectStatusSale',
      type: saleStatusHistory.STATUS_HISTORY_TYPE_ID.PAYMENT
    },
    {
      name: 'shipStatus',
      text: 'sale.ship_ship-status',
      component: 'SelectStatusSale',
      type: saleStatusHistory.STATUS_HISTORY_TYPE_ID.SHIP
    },
    {
      name: 'saleStatus',
      text: 'sale.sale_sale-status',
      component: 'SelectStatusSale',
      type: saleStatusHistory.STATUS_HISTORY_TYPE_ID.COMPLETE
    },
    {
      name: 'createUser',
      text: 'sale.sale_author',
      component: 'SelectCreateUserClearable'
    }
  ],
  line3: [
    {
      name: 'currency',
      text: 'common.input_currency',
      component: 'SearchCurrency'
    },
    {
      name: 'amountRange',
      text: 'sale.sale_price',
      component: 'SearchAmountRange'
    },
    {
      name: 'saleInfo',
      text: 'sale.sale_sale-info',
      component: 'SearchSaleInfo'
    },
    {
      name: 'ecSaleInfo',
      text: '',
      component: 'SearchECSaleInfo'
    },
    {
      name: 'productInfo',
      text: 'sale.sale_product-info',
      component: 'SearchProductNoAndProductCategory'
    },
    {
      name: 'productName',
      text: '',
      component: 'SearchProductName'
    }
  ],
  line3_OutsideStaff: [
    {
      name: 'currency',
      text: 'common.input_currency',
      component: 'SearchCurrency'
    },
    {
      name: 'saleInfo',
      text: 'sale.sale_sale-info',
      component: 'SearchSaleInfo'
    },
    {
      name: 'ecSaleInfo',
      text: '',
      component: 'SearchECSaleInfo'
    },
    {
      name: 'productInfo',
      text: 'sale.sale_product-info',
      component: 'SearchProductNoAndProductCategory'
    },
    {
      name: 'productName',
      text: '',
      component: 'SearchProductName'
    }
  ],
  line4: [
    {
      name: 'saleNotificationStatus',
      text: 'sale.sale_confirm_status',
      component: 'SelectStatusSale',
      type: saleStatusHistory.STATUS_HISTORY_TYPE_ID.STATUS_NOTIFICATION
    }
  ]
}

export default { detail }
